<template>
  <div
    id="error"
    class="error-missing-info"
    :class="{'error-missing-info--standalone': standalone}"
  >
    <svgicon name="Alerts/Warning" />
    <template v-if="missingInfoText">
      {{ missingInfoText }}
    </template>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ErrorMissingInfo',
  props: {
    missingInfoText: {
      type: String,
      required: true
    },
    standalone: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.error-missing-info {
  background-color: $color-orange-lightest;
  color: $color-red;
  padding: 0.75rem;
  border-radius: 3px;
  margin: 1rem 0;
  display: flex;
  align-items: flex-start;

  &--nomarginbottom {
    margin-bottom: 0;
  }

  @include font(text, 3, "normal");

  svg {
    fill: $color-red;
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
  }

  &--standalone {
    border: solid 1px $color-primary-cta;
  }
}
</style>
